/**
 * Lines in the CUSTOMER's numbering.
 *
 * The server holds quotation lines in insertion order, and `apply_revisions` appends — so a
 * line added to replace line 2 sits last however it is numbered. The customer reads their list
 * by serial number (Akhil, 2026-09-15: "add an item on the same position of the deleted item"),
 * so that is the order it is shown in: numeric serials ascending, anything unnumbered after
 * them in the order it came, ties left as they were.
 */
export function inSerialOrder<T extends { cust_sno: string }>(lines: readonly T[]): T[] {
  const key = (l: T): number => (/^\d+$/.test(l.cust_sno.trim()) ? Number(l.cust_sno) : Number.POSITIVE_INFINITY)
  return lines
    .map((line, index) => ({ line, index }))
    .sort((a, b) => key(a.line) - key(b.line) || a.index - b.index)
    .map((x) => x.line)
}
